import { render, staticRenderFns } from "./ClientRecordsDesk.vue?vue&type=template&id=7366b9a3"
import script from "./ClientRecordsDesk.vue?vue&type=script&lang=js"
export * from "./ClientRecordsDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports